// Free gift with purchase (Convx, 2026-10-05). Loaded on every page from
// layout/theme.liquid. Two jobs:
//
// 1. PDP add. snippets/convx-free-gift.liquid renders <convx-free-gift> with the
//    gift variant and the main product's qualifying variant ids.
//    assets/product-form.js hands its add-to-cart request to add() below, which
//    sends that request unchanged and, once the main product is in, adds the gift
//    as a nested line under it (parent_line_key). Shopify then shows the gift
//    under its parent in the cart, checkout, emails and the admin order, and
//    deletes it by itself when the parent line is removed. If the gift step fails
//    (sold out between page load and click), the main product is already in and
//    the drawer renders from the first response, so the shopper loses nothing.
//
// 2. Cart sync, every page. A gift line follows its parent's quantity (one gift
//    per unit bought) within the per-order max, then, in strict mode, is cut to
//    the units that actually ring up free. The buy-X-get-Y discount is what makes
//    the gift free; if it has ended or a code that does not combine with it has
//    displaced it, the gift would otherwise reach checkout at full price. It
//    changes the quantity of existing gift lines only; it never creates one.
//
// Spec: projects/dreame-hk/html/2026-10-05_free-gift/change-spec.md
(function () {
  if (window.ConvxFreeGift) return;

  var GIFT_FOR = '_convx_gift_for';
  var GIFT_MAX = '_convx_gift_max';
  var GIFT_STRICT = '_convx_gift_strict';
  var SOURCE = 'convx-free-gift';

  // layout/theme.liquid sets data-gift-in-cart when a gift line is already in
  // the cart at render time, so an expired discount is caught on the next page
  // view rather than at checkout.
  var script = document.currentScript;
  var giftMayBeInCart = !!(script && script.hasAttribute('data-gift-in-cart'));

  function toJSON(response) {
    return response.json();
  }

  function postJSON(url, payload) {
    return fetch(url, Object.assign(fetchConfig(), { body: JSON.stringify(payload) })).then(toJSON);
  }

  function uniqueSections(value) {
    var ids = [];
    String(value || '').split(',').forEach(function (id) {
      id = id.trim();
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  // ------------------------------------------------------------ gift settings
  // A settings object is a <convx-free-gift> card's dataset: giftVariant,
  // qualifying, max, strict, available, endsAt.

  function qualifyingIds(cfg) {
    return (cfg.qualifying || '').split(',').filter(Boolean);
  }

  function expired(cfg) {
    var endsAt = parseInt(cfg.endsAt, 10);
    return !!endsAt && Date.now() / 1000 > endsAt;
  }

  function claimable(cfg, variantId) {
    return cfg.available === 'true' &&
      !expired(cfg) &&
      qualifyingIds(cfg).indexOf(String(variantId)) !== -1;
  }

  // getAttribute, not form.id: the product form holds an <input name="id">, and
  // that named control shadows the form's id property. The PDP card lists both
  // the main form and the sticky bar's form (product-form-Sticky-<section>).
  function cardForForm(form) {
    var formId = form && form.getAttribute('id');
    if (!formId) return null;
    var cards = document.querySelectorAll('convx-free-gift[data-forms]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-forms').split(/\s+/).indexOf(formId) !== -1) return cards[i];
    }
    return null;
  }

  // Forms off the PDP (product cards, the quick-add drawer, featured product, the
  // drawer's recommendations, comparison pages) carry data-cx-gift-url when their
  // product has a Free gift metafield. The settings live in that product's PDP
  // block, so they are read from the PDP's own <convx-free-gift> tag, once per URL
  // per page view. No card on the PDP (dates, sold out) = no gift, same as there.
  var remoteSettings = {};
  var lastRemoteError = null;

  function readRemote(url) {
    if (!remoteSettings[url]) {
      remoteSettings[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          var tag = html.match(/<convx-free-gift(?=[\s>])[^>]*>/);
          if (!tag) return null;
          var el = new DOMParser().parseFromString(tag[0] + '</convx-free-gift>', 'text/html').querySelector('convx-free-gift');
          return el ? Object.assign({}, el.dataset) : null;
        })
        .catch(function (error) {
          lastRemoteError = String(error && error.message || error);
          delete remoteSettings[url];
          return null;
        });
    }
    return remoteSettings[url];
  }

  function settingsFor(form) {
    var card = cardForForm(form);
    if (card) return Promise.resolve(card.dataset);
    var url = form && form.getAttribute('data-cx-gift-url');
    return url ? readRemote(url) : null;
  }

  function toggleCard(card, variantId) {
    card.hidden = expired(card.dataset) || qualifyingIds(card.dataset).indexOf(String(variantId)) === -1;
  }

  // product-info.js fires this after every variant change, including the ones
  // made from the sticky bar's picker.
  document.addEventListener('afterVariantChanged', function (event) {
    var detail = event.detail || {};
    document.querySelectorAll('convx-free-gift').forEach(function (card) {
      if (card.dataset.section === detail.sectionId) {
        toggleCard(card, detail.variant ? detail.variant.id : '');
      }
    });
  });

  // A page left open past the end time hides its card without a reload.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('convx-free-gift[data-ends-at]').forEach(function (card) {
      if (expired(card.dataset)) card.hidden = true;
    });
  });

  // The gift line of this gift variant nested under a line of this main variant.
  function existingGift(cart, giftId, mainVariantId) {
    var byKey = {};
    cart.items.forEach(function (line) { byKey[line.key] = line; });
    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i];
      var parentKey = line.parent_relationship && line.parent_relationship.parent_key;
      if (isGiftLine(line) && String(line.variant_id) === giftId && parentKey &&
          byKey[parentKey] && byKey[parentKey].variant_id === mainVariantId) {
        return line;
      }
    }
    return null;
  }

  // Called by assets/product-form.js in place of its own fetch. Resolves with
  // what product-form.js already expects: Shopify's error object, or the added
  // line carrying `sections` for the drawer.
  function add(url, config, formData, form) {
    var first = fetch(url, config).then(toJSON);
    var settings = settingsFor(form);
    if (!settings) return first;

    return Promise.all([first, settings]).then(function (both) {
      var main = both[0];
      var cfg = both[1];
      if (!main || main.status || !main.key) return main;
      if (!cfg || !claimable(cfg, formData.get('id'))) return main;

      var max = parseInt(cfg.max, 10) || 1;
      var properties = {};
      properties[GIFT_FOR] = cfg.qualifying;
      properties[GIFT_MAX] = String(max);
      properties[GIFT_STRICT] = cfg.strict === 'true' ? '1' : '0';

      var sectionIds = uniqueSections(formData.get('sections'));
      var render = sectionIds.length
        ? { sections: sectionIds, sections_url: formData.get('sections_url') || window.location.pathname }
        : {};
      var added = parseInt(formData.get('quantity'), 10) || 1;
      var giftId = String(cfg.giftVariant);

      // Observed on this store (tools/_probe_dh_free_gift_merge.mjs): adding a variant
      // that is already a gift's parent makes Shopify open a duplicate line, then merge
      // the duplicates on the next cart change, and a gift nested under the line that
      // merges away loses its parent. So a repeat add raises the existing gift line with
      // change.js, which merges the parent lines and keeps the nesting; only a first
      // add nests a new gift line.
      return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(toJSON)
        .then(function (cart) {
          var existing = existingGift(cart, giftId, main.variant_id);
          if (existing) {
            return postJSON(routes.cart_change_url, Object.assign({
              id: existing.key,
              quantity: Math.min(existing.quantity + added, max)
            }, render));
          }
          return postJSON(url + '.js', Object.assign({
            items: [{
              id: Number(giftId),
              quantity: Math.min(added, max),
              parent_line_key: main.key,
              properties: properties
            }]
          }, render));
        })
        .then(function (gift) {
          if (!gift || gift.status) return main;
          giftMayBeInCart = true;
          if (!sectionIds.length || hasSections(gift, sectionIds)) {
            return Object.assign({}, main, { sections: gift.sections || main.sections });
          }
          // Observed on this store (see cart-promo-code.js): a cart mutation can
          // answer 200 with "sections": null. A no-op update re-renders.
          return renderOnly(sectionIds).then(function (fresh) {
            return Object.assign({}, main, { sections: hasSections(fresh, sectionIds) ? fresh.sections : main.sections });
          });
        })
        .catch(function (error) {
          if (window.console) console.error('[convx-free-gift] gift add failed', error);
          return main;
        });
    });
  }

  // Marked forms outside <product-form> post natively to /cart/add and land on
  // the cart page. Run them through add() instead, then go to the cart page as
  // before; on any failure, fall back to the native post.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute || !form.getAttribute('data-cx-gift-url') || form.closest('product-form')) return;
    event.preventDefault();
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var formData = new FormData(form);
    config.body = formData;
    add(routes.cart_add_url, config, formData, form)
      .then(function (response) {
        if (response && response.status) throw new Error(response.description || 'add failed');
        window.location.href = routes.cart_url;
      })
      .catch(function () { form.submit(); });
  });

  // ------------------------------------------------------------- cart trim

  // Same rule as cart-promo-code.js: one of these per page, the theme skips the
  // drawer on the cart page.
  function cartRenderer() {
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function rendererSectionIds(renderer) {
    var ids = [];
    if (!renderer) return ids;
    renderer.getSectionsToRender().forEach(function (section) {
      if (ids.indexOf(section.id) === -1) ids.push(section.id);
    });
    return ids;
  }

  function hasSections(cart, ids) {
    return !!cart && !!cart.sections && ids.every(function (id) {
      return typeof cart.sections[id] === 'string';
    });
  }

  function renderOnly(ids) {
    return postJSON(routes.cart_update_url, { sections: ids, sections_url: window.location.pathname });
  }

  // CartItems.renderContents() minus its focus trap: a trim can run on page load
  // with the drawer closed, and trapping focus inside a closed drawer would hijack
  // Tab for the whole page.
  function paint(renderer, cart) {
    if (!renderer || !cart.sections) return;
    var drawer = document.querySelector('cart-drawer');
    var page = document.getElementById('main-cart');
    if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
    if (page) page.classList.toggle('is-empty', cart.item_count === 0);

    renderer.getSectionsToRender().forEach(function (section) {
      var host = document.getElementById(section.section);
      var target = host && (host.querySelector(section.selector) || host);
      var html = cart.sections[section.id];
      if (target && typeof html === 'string') {
        target.innerHTML = renderer.getSectionInnerHTML(html, section.selector);
      }
    });
    if (typeof renderer.updateProductRecommendation === 'function') renderer.updateProductRecommendation();
  }

  function isGiftLine(line) {
    return !!(line.properties && line.properties[GIFT_FOR]);
  }

  function freeUnits(line) {
    return Math.floor((line.original_line_price - line.final_line_price) / line.original_price + 0.001);
  }

  // Returns { lineKey: quantity } for every gift line whose quantity must change,
  // or null. Each gift variant has one per-order budget (_convx_gift_max) shared by
  // all its lines, in cart order. A nested gift follows the units of its parent's
  // variant: one gift per unit bought, so 2 x Pocket Uni earns 贈品 x2 when the
  // budget allows.
  //
  // allowTopUp=false is the re-check after an update: it only shrinks. In strict
  // mode a gift line with units that are not free is cut to the free units and
  // never topped up in the same pass, so a budget set above the discount's
  // uses-per-order settles at the discount's number instead of looping.
  function plan(cart, allowTopUp) {
    var byKey = {};
    cart.items.forEach(function (line) { byKey[line.key] = line; });

    var budget = {};
    var updates = null;
    cart.items.forEach(function (line) {
      if (!isGiftLine(line)) return;
      var giftId = String(line.variant_id);
      if (!(giftId in budget)) budget[giftId] = parseInt(line.properties[GIFT_MAX], 10) || 1;

      // Units of the parent's variant across ALL its lines, not just the parent line:
      // Shopify can split a parent into duplicate lines of one variant (seen when the
      // drawer's + raises a parent), and the gift then hangs off either duplicate.
      // Counting the variant keeps the target the same whichever line it hangs from,
      // and matches how the buy-X-get-Y discount counts.
      var parentKey = line.parent_relationship && line.parent_relationship.parent_key;
      var base = 0;
      if (parentKey) {
        var parent = byKey[parentKey];
        if (parent) {
          cart.items.forEach(function (other) {
            if (!isGiftLine(other) && other.variant_id === parent.variant_id) base += other.quantity;
          });
        }
      } else {
        // Not nested (should not happen): count the qualifying variants instead.
        var ids = String(line.properties[GIFT_FOR]).split(',');
        cart.items.forEach(function (other) {
          if (!isGiftLine(other) && ids.indexOf(String(other.variant_id)) !== -1) base += other.quantity;
        });
      }

      var want = Math.min(base, budget[giftId]);
      if (line.properties[GIFT_STRICT] === '1' && line.original_price > 0) {
        var free = freeUnits(line);
        if (free < line.quantity) want = Math.min(want, free);
      }
      if (!allowTopUp) want = Math.min(want, line.quantity);
      want = Math.max(want, 0);
      budget[giftId] -= want;

      if (want !== line.quantity) {
        updates = updates || {};
        updates[line.key] = want;
      }
    });
    return updates;
  }

  // One change.js per round trip, then plan again on the cart it returns: Shopify
  // re-keys lines when it merges duplicates, so a batch keyed on the old cart can
  // miss, and change.js is the call seen to keep nesting through a merge.
  function applyPlan(cart, allowTopUp, rounds, state) {
    giftMayBeInCart = cart.items.some(isGiftLine);
    var updates = giftMayBeInCart ? plan(cart, allowTopUp) : null;
    if (!updates || rounds <= 0) return Promise.resolve(cart);

    var key = Object.keys(updates)[0];
    var renderer = cartRenderer();
    var ids = rendererSectionIds(renderer);
    return postJSON(routes.cart_change_url, { id: key, quantity: updates[key], sections: ids, sections_url: window.location.pathname })
      .then(function (fresh) {
        if (!fresh || !Array.isArray(fresh.items)) return cart; // e.g. a top-up past the gift's stock
        paint(renderer, fresh);
        state.changed = fresh;
        return applyPlan(fresh, allowTopUp, rounds - 1, state);
      });
  }

  // Follow the parents (may add gift units to existing gift lines), then re-check
  // what the discount actually made free (only removes).
  function reconcile(cart) {
    var state = { changed: null };
    return applyPlan(cart, true, 6, state)
      .then(function (after) { return applyPlan(after, false, 6, state); })
      .then(function () {
        if (state.changed) {
          document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { source: SOURCE, cartData: state.changed } }));
        }
      });
  }

  var syncing = null;
  var again = false;

  function sync(cart) {
    if (syncing) {
      again = true; // a change landed mid-sync: run once more on a fresh read
      return syncing;
    }
    var source = cart && Array.isArray(cart.items) && typeof cart.item_count === 'number'
      ? Promise.resolve(cart)
      : fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(toJSON);
    syncing = source
      .then(reconcile)
      .catch(function (error) {
        if (window.console) console.error('[convx-free-gift] cart sync failed', error);
      })
      .then(function () {
        syncing = null;
        if (again) {
          again = false;
          sync();
        }
      });
    return syncing;
  }

  // Cart-shaped payloads (quantity changes, discount codes) are trimmed directly.
  // An add-to-cart answers with a line, not a cart, so it costs a /cart.js read,
  // and only when a gift could be in the cart.
  function onCartEvent(event) {
    var detail = event.detail || {};
    if (detail.source === SOURCE) return;
    var data = detail.cartData;
    if (data && Array.isArray(data.items) && typeof data.item_count === 'number') {
      sync(data);
    } else if (giftMayBeInCart) {
      sync();
    }
  }

  document.addEventListener('afterUpdateQuantity', onCartEvent);
  document.addEventListener('afterCartChanged', onCartEvent);

  if (giftMayBeInCart) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { sync(); });
    } else {
      sync();
    }
  }

  // _settingsFor and _lastRemoteError are for tools/_probe_dh_free_gift_*.mjs.
  window.ConvxFreeGift = { add: add, sync: sync, _settingsFor: settingsFor, _lastRemoteError: function () { return lastRemoteError; } };
})();
